import Phaser from 'phaser';
import { FACTION_COLORS } from '../../shared/factions';
import type { FactionId } from '../../shared/types';

/**
 * Radial burst spawned at skill cast point.
 * 10 small circles fanned out → 250ms outward tween → destroy.
 * Color = faction primary (falls back to white when faction unknown).
 */
export const SKILL_BURST_PARTICLE_COUNT = 10;
export const SKILL_BURST_RADIUS_PX = 32;
export const SKILL_BURST_DURATION_MS = 250;

export function skillCastBurst(
  scene: Phaser.Scene,
  x: number,
  y: number,
  faction: FactionId | null,
): number {
  const color = faction ? FACTION_COLORS[faction].primary : 0xffffff;
  let spawned = 0;
  for (let i = 0; i < SKILL_BURST_PARTICLE_COUNT; i++) {
    const angle = (Math.PI * 2 * i) / SKILL_BURST_PARTICLE_COUNT;
    const dx = Math.cos(angle) * SKILL_BURST_RADIUS_PX;
    const dy = Math.sin(angle) * SKILL_BURST_RADIUS_PX;
    let p: Phaser.GameObjects.Arc;
    try {
      p = scene.add.circle(x, y, 3, color, 0.95);
      if (typeof (p as { setDepth?: unknown }).setDepth === 'function') p.setDepth(7);
    } catch {
      continue;
    }
    try {
      scene.tweens.add({
        targets: p,
        x: x + dx,
        y: y + dy,
        alpha: 0,
        scale: 0.3,
        duration: SKILL_BURST_DURATION_MS,
        ease: 'Cubic.easeOut',
        onComplete: () => { try { p.destroy(); } catch { /* noop */ } },
      });
      spawned++;
    } catch {
      try { p.destroy(); } catch { /* noop */ }
    }
  }
  return spawned;
}
